export default __webpack_public_path__ + "static/media/t41.219d1a72.jpg";